module.exports = __webpack_public_path__ + "img/AUTO_HOSPITALISATION_DESACTIVE.897987af.svg";